import React, { FC, HTMLAttributes, useState } from "react";

import ApiStateModal from "../../../components/reusable-ui/basic-modal";

import { MESSAGE_TYPE } from "../../../data/constants";
import "./style.scss";
import { useDispatch } from "react-redux";
import { fetchCommonData, savePnlData } from "../../../redux/slices";
import TopActionBar from "./top-action-bar";
import { PNL_STATEMENT_INTRO_STEPS } from "../../../data/accounting-constants";
import ExpenseUploadModal from "./expense-upload-modal";
import RenderIntroSteps from "../../../components/reusable-ui/intro-steps";
import PnlStatementView from "./pnl-statement-view";
import { ENDPOINT } from "../../../services/apiUrls";
import { METHODS } from "../../../data/api-method-constants";
import history from "../../../history";
import { DOWNLOADS_PAGE_ROUTE } from "../../../data/routes-constants";

const PnlStatement: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const [apiStateModalData, setApiStateModalData] = useState<any>({
      show: false,
      modalText: "",
    }),
    [isExpenseModalOpen, setIsExpenseModalOpen] = useState<boolean>(false),
    [showPnlData, setShowPnlData] = useState<boolean>(false),
    [selectedDateRange, setSelectedDateRange] = useState({
      startDate: "",
      endDate: "",
    }),
    [isDownload, setIsDownload] = useState<boolean>(false);
  const dispatch = useDispatch();

  const viewPnlData = (data: any) => {
    const callback = (res: any) => {
      if (!res.code) {
        setShowPnlData(true);
        // setSelectedDateRange({
        //   startDate: "22.02.2023",
        //   endDate: "29.02.2023",
        // });
      }
    };
    dispatch(
      fetchCommonData({
        method: METHODS.POST,
        body: data,
        url: ENDPOINT.PNL_STATEMENT.getProfitAndLossApi,
        action: savePnlData,
        callback,
      })
    );
  };

  const handleCloseApiStateModal = () => {
    setApiStateModalData({ show: false });
    history.push({ pathname: DOWNLOADS_PAGE_ROUTE });
  };

  function renderIntroScreen() {
    return (
      <div
        className={`flex flex-col items-center justify-center m-20 bg-white
          h-[calc(100vh-206px)] w-[calc(100%-40px)] sm:m-16 sm:w-[calc(100%-32px)]
          sm:h-auto sm:py-20
        `}
      >
        <p className="text-14 text-[#666666] leading-none mb-14 sm:text-[14px]">
          New to this feature?
        </p>
        <p className="text-24 text-[#2A77F2] leading-none font-bold mb-30">
          Lets get you started !
        </p>
        <RenderIntroSteps introStepsList={PNL_STATEMENT_INTRO_STEPS} />
      </div>
    );
  }

  return (
    <div className={`pnl-statement-container`}>
      <TopActionBar
        viewPnlData={viewPnlData}
        openExpenseModal={() => setIsExpenseModalOpen(true)}
        setApiStateModalData={setApiStateModalData}
        setActionMode={setIsDownload}
        setSelectedDateRange = {setSelectedDateRange}
      />
      {showPnlData ? (
        <PnlStatementView selectedDateRange={selectedDateRange} openModal={() => setIsExpenseModalOpen(true)}/>
      ) : (
        renderIntroScreen()
      )}
      {apiStateModalData?.show ? (
        <ApiStateModal
          modalType={MESSAGE_TYPE.success}
          open={apiStateModalData?.show}
          handleClose={handleCloseApiStateModal}
          mainText={apiStateModalData?.modalText || ""}
        ></ApiStateModal>
      ) : null}
      {isExpenseModalOpen ? (
        <ExpenseUploadModal
          isModeDownload={isDownload}
          onModalClose={() => setIsExpenseModalOpen(false)}
        />
      ) : null}
    </div>
  );
};

export default PnlStatement;
